import * as React from "react";
import { PropsWithChildren } from "react";
import { Maybe } from "types/thecookies";

import { TypeForm } from "../../Forms/domain/Forms";
import { CatchEmailForm } from "../../Forms/Views/CatchEmail/CatchEmailForm";
import withForm from "../../Forms/withForm";

type PropsCaptureEmails = PropsWithChildren<{
  text: Maybe<string>;
  highlight?: Maybe<string>;
  cta: Maybe<string>;
  is_molecule?: boolean;
}>;

const CatchEmail: React.FC<PropsCaptureEmails> = (
  props: PropsCaptureEmails,
) => {
  const CatchEmailFormUse = withForm(CatchEmailForm, TypeForm.BASIC, "footer");

  if (props.is_molecule)
    return (
      <div className={"m-catch-emails"}>
        <p className={"a-title"}>
          {props.text}
          {props.highlight && (
            <span className={"highlight highlight--orange"}>
              {props.highlight}
            </span>
          )}
        </p>
        <CatchEmailFormUse />
      </div>
    );
  return (
    <div className={"o-catch-emails"}>
      <div className={"c-catch-emails"}>
        <p className={"a-title"}>
          {props.text}
          {props.highlight && (
            <span className={"highlight highlight--orange"}>
              {props.highlight}
            </span>
          )}
        </p>
        <CatchEmailFormUse />
      </div>
    </div>
  );
};

export default CatchEmail;
